<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-container fluid>
      <b-alert variant="danger" show v-if="spei">Queda en espera de recibir el SPEI.
      </b-alert>
      <div class="divFlexStart mginTop15">
        <p class="boldBlue">Consultar Recibos</p>
      </div>
      <b-row>
        <b-col>
          <p v-if="kpi != null" class="alert alert-info text-center" style="font-size: 2em;">
            Saldo actual del paciente <b>{{ kpi.totalSaldo| moneda }}</b>
            <span v-if="saldoBloqueado" style="color: red"> (Congelado)</span>
          </p>
          <p v-else class="alert alert-info text-center">Obteniendo saldo</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div style="display: flex;
         justify-content: space-around;
          ">
            <div></div>
            <h5>Recibos</h5>
            <b-button type="button" variant="primary" style="color: white;" id="button" target="_blank"  v-on:click="abrirFacturacion()">Consultar recibos V3</b-button>
          </div>
          <b-table id="recibos" thead-tr-class="columnas" :items="datosTablaRecibo" :fields="fields"
            :per-page="registrosPorPagina" :current-page="paginaActual" responsive="true" class="parrafos" fixed>
            <template v-slot:cell(montopagado)="row">
              {{ row.item.montopagado | moneda }}
            </template>
            <template v-slot:cell(saldo)="row">
              {{ row.item.saldo | moneda }}
            </template>
            <template v-slot:cell(montoReembolso)="row">
              <span v-if="row.item.montoReembolso != null">
                -{{ row.item.montoReembolso | moneda }}
              </span>
            </template>
            <template v-slot:cell(aplicacion)="row">
              {{ row.item.aplicacion | moneda }}
            </template>
            <template v-slot:cell(nombreTipoRecibo)="row">
              <b-badge variant="primary">{{row.item.nombreTipoRecibo}}</b-badge>
            </template>
            <template v-slot:cell(Estatus)="row">
              <b-badge v-if="row.item.activo" variant="success">Activo</b-badge>
              <b-badge v-else variant="danger">Cancelado</b-badge>
            </template>
            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <!--                                <b-button-->
                <!--                                        title="Detalle del recibo"-->
                <!--                                        size="sm"-->
                <!--                                        @click="detalle(row.item)"-->
                <!--                                        variant="outline-danger"-->
                <!--                                ><em class="fa fa-eye"></em></b-button>-->
                <b-button title="Imprimir" size="sm" @click="imprimir(row.item)" variant="outline-info"
                  :disabled="row.item.loaderRecibo"><em v-if="!row.item.loaderRecibo" class="fa fa-print"></em>
                  <b-spinner small v-else label="Spinning"></b-spinner>
                </b-button>
                <b-button v-if="
                    !row.item.facturado &&
                    !row.item.seleccion &&
                    row.item.activo
                  " title="Facturar" size="sm" @click="facturar(row.item)" variant="outline-primary"><em
                    class="fa fa-file"></em></b-button>
              </b-button-group>
            </template>
            <template v-slot:cell(fecha)="row">
              {{ row.item.fecha | formatoFechaHora }}
            </template>
            <template v-slot:cell(idRecibo)="row">
              {{
                row.item.numeroRecibo !== null
                    ? row.item.numeroRecibo
                    : row.item.idRecibo
              }}
            </template>
            <template v-slot:cell(Selec.)="row">
              <b-form-checkbox v-if="
                  !row.item.facturado &&
                  row.item.activo &&
                  $localStorageService.can('BT_facturar')
                " :id="'checkbox-' + row.item.idRecibo" v-model="row.item.seleccion"
                :name="'checkbox-' + row.item.idRecibo" value="accepted" unchecked-value="not_accepted">
              </b-form-checkbox>
            </template>
          </b-table>
          <div align="center" v-if="loaderRecibo">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loaderRecibo">
            <b-alert v-if="datosTablaRecibo.length === 0" variant="warning" show>No hay datos
            </b-alert>
          </b-col>
          <b-col v-if="!loaderRecibo">
            <b-pagination v-if="
                datosTablaRecibo !== undefined && datosTablaRecibo.length > 15
              " align="center" v-model="paginaActual" :total-rows="datosTablaRecibo.length"
              :per-page="registrosPorPagina" aria-controls="my-table1"></b-pagination>
          </b-col>
        </b-col>
        <b-col cols="12">
          <b-button v-if="$localStorageService.can('BT_facturar')" :disabled="loaderFacturar" variant="primary"
            @click="facturarVarios()">
            <span v-if="!loaderFacturar">Facturar</span>
            <span v-if="loaderFacturar">
              <b-spinner small></b-spinner>Facturando...
            </span>
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <h5>Facturas</h5>
          <b-table id="Pendientes" thead-tr-class="columnas" :items="datosTablaFacturas" :fields="fieldsFacturas"
            :per-page="registrosPorPaginaFac" :current-page="paginaActualfa" responsive="true" class="parrafos" fixed>
            <template v-slot:cell(fecha)="row">
              {{ row.item.fecha | formatoFechaHora }}
            </template>
            <template v-slot:cell(Acciones)="row">
              <b-button-group v-if="row.item.estatus.includes('xito')">
                <b-button title="Cancelar factura" size="sm" @click="cancelarFactura(row.item)" variant="outline-danger"
                  :disabled="row.item.loadercancelar"><em v-if="!row.item.loadercancelar" class="fa fa-close"></em>
                  <b-spinner small v-else label="Spinning"></b-spinner>
                </b-button>
                <b-button title="Imprimir" size="sm" @click="imprimirFactura(row.item)" variant="outline-info"
                  :disabled="row.item.loaderRecibo"><em v-if="!row.item.loaderRecibo" class="fa fa-print"></em>
                  <b-spinner small v-else label="Spinning"></b-spinner>
                </b-button>
              </b-button-group>
            </template>
            <template v-slot:cell(total)="row">
              {{ row.item.total | moneda }}
            </template>
          </b-table>
          <div align="center" v-if="loaderFacturas">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loaderFacturas">
            <b-alert v-if="datosTablaFacturas.length === 0" variant="warning" show>No hay datos
            </b-alert>
          </b-col>
          <b-col v-if="!loaderFacturas">
            <b-pagination v-if="
                datosTablaFacturas !== undefined &&
                datosTablaFacturas.length > 10
              " align="center" v-model="paginaActualfa" :total-rows="datosTablaFacturas.length"
              :per-page="registrosPorPaginaFac" aria-controls="recibos"></b-pagination>
          </b-col>
        </b-col>

        <b-modal v-model="showModalFactura" title="Factura" centered>
          <b-container fluid>
            <b-row>
              <b-col>
                <b-form-group id="idfactura" label="RFC para factura:" label-for="input-1">
                  <b-form-select v-model="factura.idDatosFiscales" class="mb-3">
                    <b-form-select-option v-for="item in datosFiscales" :key="item.rfc" :value="item">{{ item.rfc }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group id="idfactura" label="Nombre de la Razón Social:" label-for="input-1">
                  <p v-if="factura.idDatosFiscales != null"> {{factura.idDatosFiscales.nombreCompleto}}</p>
                  <p v-else></p>
                </b-form-group>

                <b-form-group label="Correo Electrónico:" label-for="input-2">
                  <p v-if="factura.idDatosFiscales != null"> {{factura.idDatosFiscales.correo}}</p>
                  <p v-else></p>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group id="input-group-1" label="Uso de CFDI:" label-for="input-1">
                  <b-form-select v-model="factura.cfdi" class="mb-3" v-if="factura.idDatosFiscales != null && factura.idDatosFiscales.tipoPersona == 2">
                    <b-form-select-option v-if="aparecerDOI" value="D01">Honorarios médicos, dentales y gastos
                      hospitalarios
                      (D01)
                    </b-form-select-option>
                    <b-form-select-option value="G03">Gastos en general (G03)
                    </b-form-select-option>
                  </b-form-select>

                  <b-form-select v-model="factura.cfdi" class="mb-3" v-if="factura.idDatosFiscales != null && factura.idDatosFiscales.tipoPersona == 1">
                    <b-form-select-option value="G03">Gastos en general (G03)</b-form-select-option>
                  </b-form-select>
                  
                </b-form-group>
              </b-col>
            </b-row>
            <span style="font-size: x-small; color: darkgray">Opciones avanzadas</span>
            <hr style="margin-top: 0.1rem">
            <b-row>
              <b-col>
                <b-form-checkbox id="checkbox-1" class="check-facturacion" v-model="factura.datosPaciente" name="checkbox-1">
                  Mostrar datos del paciente
                </b-form-checkbox>
              </b-col>
              <b-col>
                <b-form-checkbox id="checkbox-2" class="check-facturacion" v-model="factura.desglosada" name="checkbox-2">
                  Factura desglosada
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-container>
          <div slot="modal-footer" class="btns">
            <b-button variant="outline-primary" :disabled="loaderFacturar" @click="realizarFactura()">
              <span v-if="!loaderFacturar">Facturar</span>
              <span v-if="loaderFacturar">
                <b-spinner small></b-spinner>
                Cargando...
              </span>
            </b-button>
            <b-button variant="outline-danger" class="ml-2" :disabled="loaderFacturar" @click="cerrarModal()">Cancelar
            </b-button>
          </div>
        </b-modal>

        <b-modal
          v-model="showModalFiscales"
          title="Verificar Datos Fiscales"
          size="lg"
          centered
        >
          <div fluid>
            <b-row>
              <b-col>
                <b-form-group>
                  <b-form-radio-group @input="listaFiscal"  id="tipo" v-model="datoFiscal.tipoPersona"
                                      name="tipo">
                    <b-form-radio :value="2">Fisica</b-form-radio>
                    <b-form-radio :value="1">Moral</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group>
                  <label for="rfc">RFC
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input id="rfc" name="rfc" placeholder="RFC"
                                  v-model="$v.datoFiscal.rfc.$model"
                                  @input="datoFiscal.rfc = datoFiscal.rfc.toUpperCase()"
                                  :state="validateState('rfc')"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group>
                  <label for="regimen">Regimen Fiscal
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-select id="regimen" name="regimen" placeholder="Regimen Fiscal"
                                   v-model="$v.datoFiscal.regimenFiscal.$model"
                                   :options="regimenFiscales"
                                   value-field="idRegimenFiscal"
                                   text-field="nombre"
                                   :state="validateState('regimenFiscal')"
                    ></b-form-select>

                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <h5>Razón social</h5>
            <hr>
            <b-row v-if="datoFiscal.tipoPersona === 2">
              <b-col>
                <b-form-group>
                  <label for="nombre">Nombre(s)
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input v-model="$v.datoFiscal.nombre.$model"
                                  :state="validateState('nombre')"
                                  id="nombre" name="nombre" placeholder="Nombre"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
                <b-form-group label-for="input-name">
                  <h5>Nombre Completo: <span class="text-secondary"><small>{{datoFiscal.nombreCompleto}}</small></span></h5>
                  
                  <p class="txt-rojo">El nombre completo no coincide con el nombre y/o apellidos</p>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="datoFiscal.tipoPersona === 1">
              <b-col>
                <b-form-group>
                  <label for="nombre">Nombre de la razón social
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input v-model="$v.datoFiscal.nombreCompleto.$model"
                                  :state="validateState('nombreCompleto')"
                                  id="nombreCompleto" name="nombreCompleto" placeholder="Nombres"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="datoFiscal.tipoPersona === 2">
              <b-col>
                <b-form-group>
                  <label for="paterno">Apellido paterno
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input id="paterno" name="paterno" placeholder="Apellido paterno"
                                  v-model="$v.datoFiscal.paterno.$model"
                                  :state="validateState('paterno')"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group>
                  <label for="materno">Apellido materno
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input id="materno" name="materno" placeholder="Apellido materno"
                                  v-model="$v.datoFiscal.materno.$model"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group>
                  <label for="correo">Correo electrónico
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input type="email" id="correo" name="correo" placeholder="Correo"
                                  v-model="$v.datoFiscal.correo.$model"
                                  :state="validateState('correo')"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <h5>Dirección <span class="text-secondary"><small>(Opcional)</small></span></h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group>
                  <label for="calle">Calle
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input id="calle" name="calle" placeholder="Calle" v-model="datoFiscal.calle"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group>
                  <label for="numero">Número
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input id="numero" name="numero" placeholder="Número" v-model="datoFiscal.numero"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group>
                  <label for="cp">CP
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input id="cp" name="cp" placeholder="CP" v-model="$v.datoFiscal.cp.$model"
                                  :state="validateState('cp')"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group>
                  <label for="colonia">Colonia
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input id="colonia" name="colonia" placeholder="Colonia"
                                  v-model="datoFiscal.colonia"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group>
                  <label for="pais">País de residencia
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input id="pais" name="pais" placeholder="País" v-model="datoFiscal.pais"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group>
                  <label for="estado">Estado
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input id="estado" name="estado" placeholder="Estado" v-model="datoFiscal.estado"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div slot="modal-footer" class="btns">
            <b-button variant="outline-primary" :disabled="loaderFiscales" @click="actualizar()">
              <span v-if="!loaderFiscales">Actualizar</span>
              <span v-if="loaderFiscales">
                            <b-spinner small></b-spinner>
                        Cargando...
                        </span>
            </b-button>
            <b-button variant="outline-danger" class="ml-2" :disabled="loaderFiscales" @click="cerrarModalFiscales()">Cancelar</b-button>
          </div>
        </b-modal>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div style="display: flex;
         justify-content: space-around;
          ">
            <h5>Reembolsos</h5>
          </div>
          <b-table id="recibos" thead-tr-class="columnas"
                   :items="datosTablaReembolsos" :fields="fieldsReembolsos"
                   :per-page="registrosPorPagina"
                   :current-page="paginaActualReembolsos" responsive="true">
            <template v-slot:cell(montoSaldoBloqueado)="row">
              {{ row.item.montoSaldoBloqueado | moneda }}
            </template>
            <template v-slot:cell(montoActualKpi)="row">
              {{ row.item.montoActualKpi | moneda }}
            </template>
            <template v-slot:cell(fechaBloqueo)="row">
              {{ row.item.fechaBloqueo | formatoFechaHora }}
            </template>
            <template v-slot:cell(fechaLiberacion)="row">
              {{ row.item.fechaLiberacion | formatoFechaHora }}
            </template>
            <template v-slot:cell(registroActivo)="row">
              {{ row.item.registroActivo | sino }}
            </template>
            <template v-slot:cell(registroActivo)="row">
              <b-badge v-if="row.item.registroActivo && row.item.fechaLiberacion == null" variant="success">Activo</b-badge>
              <b-badge v-if="row.item.registroActivo && row.item.fechaLiberacion != null" variant="success">Finalizado</b-badge>
              <b-badge v-if="!row.item.registroActivo" variant="danger">Inactivo/Cancelado</b-badge>
            </template>
            <template v-slot:cell(detalles)="row">
              <div v-if="row != null && row.item != null && row.item.detalles != null">
                <b-table
                    :items="row.item.detalles"
                    :fields="fieldsReembolsosDetalle"
                         responsive="true">
                  <template v-slot:cell(montoRecibo)="row">
                    {{ row.item.montoRecibo | moneda }}
                  </template>
                  <template v-slot:cell(montoReembolso)="row">
                    {{ row.item.montoReembolso | moneda }}
                  </template>
                  <template v-slot:cell(tratamientos)="row">
                    <b-button @click="abrirModalTratamientos(row.item)">Ver tratamientos</b-button>
                  </template>
                </b-table>
              </div>
              <div v-else>
                  Sin recibos
              </div>
<!--              <ul>-->
<!--                <li v-for="det in row.item.detalles" v-bind:key="det.idRecibo">-->
<!--                  <span >{{det.idRecibo}}</span>-->
<!--                </li>-->
<!--              </ul>-->
<!--              <b-table-->
<!--                  v-if="row.item.detalles != null"-->
<!--                  :items="row.item.detalles"-->
<!--                  :fields="fieldsReembolsosDetalle"-->
<!--                       responsive="true" class="parrafos" fixed>-->

<!--              </b-table>-->

            </template>
          </b-table>
          <div align="center" v-if="loaderReembolsos">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loaderReembolsos">
            <b-alert v-if="datosTablaReembolsos.length === 0" variant="warning" show>No hay datos
            </b-alert>
          </b-col>
          <b-col v-if="!loaderReembolsos">
            <b-pagination v-if="
                datosTablaReembolsos !== undefined && datosTablaReembolsos.length > 15
              " align="center" v-model="paginaActualReembolsos" :total-rows="datosTablaReembolsos.length"
                          :per-page="registrosPorPagina" aria-controls="my-table1"></b-pagination>
          </b-col>
        </b-col>
      </b-row>
      <b-tabs>
        <b-tab title="Movimientos, transferencias y cashback">
          <ListaMovimientosTodosAceptadosPorPaciente />
        </b-tab>
        <b-tab title="Historico">
          <HistorialRecibosVistaDocumentos />
        </b-tab>
      </b-tabs>
      <b-col v-if="datosFiscales.length === 0">
        <b-alert variant="warning" show>Sin datos fiscales</b-alert>
      </b-col>
    </b-container>
    <b-modal size="md" v-model="modalTratamientos">
      <b-table id="tratamientos"
        thead-tr-class="columnas" 
        :items="datosTablaTratamientos" 
        :fields="fieldsTratamientos" 
        responsive="true">
      </b-table>
    </b-modal>
  </div>
</template>
<script>
  import * as JSZip from "jszip";
  import {
    saveAs
  } from "file-saver";
  import ListaMovimientosTodosAceptadosPorPaciente from "../movimientos/ListaMovimientosTodosAceptadosPorPaciente";
  import {
    KpiService
  } from "../../apiServices/kpi/KpiService";
  import HistorialRecibosVistaDocumentos from "../movimientos/recibos/HistorialRecibosVistaDocumentos";
  import {maxLength, numeric, required, email, minLength} from "vuelidate/lib/validators";

  export default {
    name: "documents",
    components: {
      HistorialRecibosVistaDocumentos,
      ListaMovimientosTodosAceptadosPorPaciente,
    },
    props: {
      pti: Number,
    },
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      kpi: null,
      datosTablaRecibo: [],
      regimenFiscales:[],
      recibos: [],
      datosTablaFacturas: [],
      datosFiscales: [],
      loaderRecibo: false,
      loaderFacturas: false,

      datosTablaReembolsos: [],
      datosTablaTratamientos: [],
      loaderReembolsos: false,
      paginaActualReembolsos: 1,
      fieldsReembolsos: [
        {
          key: "idReembolso",
          label: "Folio solicitud",
          sortable: true
        },
        {
          key: "montoSaldoBloqueado",
          label: "Saldo solicitado reembolso",
          sortable: true
        },
        {
          key: "montoActualKpi",
          label: "Saldo Congelado",
          sortable: true
        },
        {
          key: "fechaBloqueo",
          label: "Fecha solicitud",
          sortable: true
        },
        {
          key: "registroActivo",
          label: "Estatus",
          sortable: true
        },
        {
          key: "fechaLiberacion",
          label: "Fecha liberación",
          sortable: true
        },
        {
          key: "folioReembolsoERP",
          label: "Folio ERP",
          sortable: true
        },
        {
          key: "detalles",
          label: "Recibos",
          sortable: true
        },

      ],
      fieldsReembolsosDetalle: [
        {
          key: "idRecibo",
          label: "Recibo",
          sortable: true,
          thStyle: { width: "100px" },
        },
        {
          key: "montoRecibo",
          label: "Monto recibo",
          sortable: true,
          thStyle: { width: "100px" },
        },
        {
          key: "montoReembolso",
          label: "Monto reembolsable",
          sortable: true,
          thStyle: { width: "100px" },
        },
        {
          key: "tratamientos",
          label: "Tratamientos",
        },

      ],

      fields: [
        "Selec.",
        {
          key: "fecha",
          label: "Fecha",
          sortable: true
        },
        {
          key: "clinica",
          label: "Clinica",
          sortable: true
        },
        {
          key: "montopagado",
          label: "Pago",
          sortable: true
        },
        {
          key: "montoReembolso",
          label: "Reembolso",
          sortable: true
        },
        {
          key: "aplicacion",
          label: "Aplicacion de saldo",
          sortable: true
        },
        {
          key: "saldo",
          label: "Saldo",
          sortable: true
        },
        {
          key: "idRecibo",
          label: "Recibo",
          sortable: true
        },
        {
          key: "nombreTipoRecibo",
          label: "Tipo",
          sortable: true
        },
        "Estatus",
        "Acciones",
      ],
      fieldsFacturas: [{
          key: "idFactura",
          label: "No.",
          sortable: true
        },
        {
          key: "total",
          label: "Total",
          sortable: true
        },
        {
          key: "idRecibo",
          label: "Recibo",
          sortable: true
        },
        {
          key: "clinica",
          label: "Clínica",
          sortable: true
        },
        {
          key: "estatus",
          label: "Estatus",
          sortable: true
        },
        {
          key: "fecha",
          label: "Fecha",
          sortable: true
        },
        "Acciones",
      ],
      fieldsTratamientos: [
      {
          key: "idTratamiento",
          label: "Id tratamiento",
          sortable: true
        },
        {
          key: "nombreTratamiento",
          label: "Tratamiento",
          sortable: true
        },
        {
          key: "montoReembolso",
          label: "Monto reembolsado",
          sortable: true
        },
      ],
      registrosPorPagina: 15,
      registrosPorPaginaFac: 15,
      paginaActual: 1,
      paginaActualfa:1,

      registrosPorPaginaFacturta: 15,
      paginaActualFactura: 1,

      idPaciente: null,
      idDatosFiscales: null,

      documents: {
        modificacion: null,
        pago: null,
      },
      factura: {
        recibos: [],
        idDatosFiscales: null,
        cfdi: null,
        idClinica: null,
        datosPaciente: false,
        desglosada: false,
        permiso: null
      },

      datoFiscal: {
        idPaciente: null,
        idDatosFiscales: null,
        nacionalidad: null,
        rfc: null,
        tipoPersona: 1,
        nombre: null,
        nombreCompleto: null,
        paterno: null,
        materno: null,
        calle: null,
        numero: null,
        colonia: null,
        cp: null,
        pais: null,
        estado: null,
        correo: null,
        regimenFiscal: null
      },

      selected: [],
      seen: true,
      can: "",
      for_pago: "",
      ref: "",
      terminal: "",
      num_tarj: "",
      msi: "",
      txarea: [],
      ruta: "dashboard",
      btn_apliSal: "",
      validated: 0,
      visible: false,
      showModalFactura: false,
      showModalFiscales: false,
      loaderFacturar: false,
      loaderFiscales: false,
      spei: false,
      aparecerDOI: true,
      kpiService: new KpiService(),
      regimenFiscal: null,
      saldoBloqueado: false,
      modalTratamientos: false,
    }),

    validations() {
      if (this.datoFiscal.tipoPersona === 2) {
        return {
          datoFiscal: {
            rfc: {required, minLength: minLength(13), maxLength: maxLength(13)},
            regimenFiscal: {required},
            nombre: {required},
            paterno: {required},
            materno: {},
            correo: {required, email},
            cp: {numeric, maxLength: maxLength(5), required},
          }
        }
      } else {
        return {
          datoFiscal: {
            rfc: {required, minLength: minLength(12), maxLength: maxLength(12)},
            regimenFiscal: {required},
            nombreCompleto: {required},
            correo: {required, email},
            cp: {numeric, maxLength: maxLength(5), required},
          }
        }
      }
    },

    created() {
      this.debug = this.$localStorageService.getDebug();

      this.idPaciente = this.$route.params.id;
      this.obtenerRecibos();
      this.obtenerRfcs();
      this.obtenerFacturas();
      this.listaFiscal();
      this.obtenerFormasPago();
      this.verificarBloqueo();
      this.obtenerReembolsos();



      const parametros = {idPaciente: this.$route.params.id}
      this.kpiService.traerKpiPaciente(parametros).then(kpi => {
        this.kpi = kpi
        this.$root.$emit('paciente', {
          idPaciente: this.idPaciente
        })

      })


      var element2 = document.querySelectorAll("b-button#botton");
      element2.addEventListener("click", () => {

      });



    },
    methods: {
      verificarBloqueo(){
        this.saldoBloqueado = false;
        this.$http.post(this.$api + "ws/reembolsos/existeReembolsoProceso", {"idPaciente": this.idPaciente})
            .then((response) => {
              this.saldoBloqueado = response.data.success;
            });
      },
      listaFiscal() {
        const parametros = {idTipoPersona: this.datoFiscal.tipoPersona}
        this.$http.post(this.$api + 'catalogos/regimenFiscal/obtener/activo',parametros).then(respuesta => {
          if (respuesta.data.data) {
            this.regimenFiscales = respuesta.data.data;
          }
        })
            .catch((err) => {
              this.errorMensaje(err);
            });
      },

      obtenerRecibos() {
        this.loaderRecibo = true;
        this.datosTablaRecibo = [];
        this.$http
          .post(
            this.$api + "fiscales/obtener/recibos", this.idPaciente
          )
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.datosTablaRecibo = [];
              respuesta.data.data.map((it) => {
                it.loaderRecibo = false;
                this.datosTablaRecibo.push(it)
              });
            }
          })
          .finally(() => {
            this.loaderRecibo = false;
          });
      },
      cambiarListaRecibos(item) {
        this.datosTablaRecibo = [];
        this.recibos.map((value) => {
          if (value.tipoRecibo === item) {
            this.datosTablaRecibo.push(value);
          }
        });
      },
      obtenerFacturas() {
        this.loaderFacturas = true;
        this.datosTablaFacturas = [];
        this.$http
          .post(
            this.$api + "fiscales/obtener/facturas", this.idPaciente
          )
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.datosTablaFacturas = [];
              respuesta.data.data.map((it) => {
                it.loaderRecibo = false;
                it.loadercancelar = false;
                this.datosTablaFacturas.push(it)
              });
            }
          })
          .finally(() => {
            this.loaderFacturas = false;
          });
      },
      obtenerRfcs() {
        const params = {
          idPaciente: this.idPaciente
        }
        this.$http
          .post(
            this.$api +
            "fiscales/obtener/datosFiscales", params   )
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.datosFiscales = respuesta.data.data.filter(t => t.activo);
            }
          });
      },
      obtenerReembolsos() {
        this.loaderReembolsos = true;
        this.datosTablaReembolsos = [];
        this.$http
            .post(
                this.$api + "ws/reembolsos/obtenerReembolsosPaciente", {"idPaciente":this.idPaciente}
            )
            .then((respuesta) => {
              if (respuesta.data.data) {
                this.datosTablaReembolsos = [];
                respuesta.data.data.map((it) => {
                  it.loaderReembolsos = false;
                  this.datosTablaReembolsos.push(it)
                });
              }
            })
            .finally(() => {
              this.loaderReembolsos = false;
            });
      },
      onSelect(items) {
        this.selected = items;
      },
       abrirFacturacion() {
        window.open(this.$baseURLFacturacion);
      },
      getAlternateLabel(count) {
        let plural = "";

        if (count > 1) {
          plural = "s";
        }

        return `${count} user${plural} selected`;
      },
      agregarPago: function () {
        if (!this.can || !this.for_pago || !this.terminal || !this.num_tarj) {
          alert("Los campos son obligatorios.");
        } else {
          // alert("Cargando pago");
          this.txarea.push(
            "$" +
            this.can +
            " - " +
            this.for_pago +
            " - " +
            this.terminal +
            " - [" +
            this.ref +
            "]"
          );
          this.validated = 1;
        }
      },
      cobrar: function () {
        if (!this.txarea) {
          alert("Necesitar agregar un cobro");
        } else {
          this.visible = true;
          this.validated = 2;
        }
      },
      quitar: function () {
        if (!this.txarea) {
          alert("Necesitar agregar un cobro");
        } else {
          this.txarea = [];
        }
      },
      imprimirFactura(item) {

        if (item.url === null) {
          item.loaderRecibo = true
          this.$http
            .get(this.$api + "reportes/factura?idFactura=" + item.idFactura)
            .then((respuesta) => {
              if (respuesta.data.data) {
                const datos = respuesta.data.data;
                this.descargarFactura(datos);
              }
            })
            .finally(() => {
              item.loaderRecibo = false
            });
        } else {
          window.open(item.url);
        }
      },
      cancelarFactura(item) {
        item.loadercancelar = true
        this.$http
          .get(
            this.$api + "facturacion/cancelarFactura?idFactura=" + item.idFactura
          )
          .then((respuesta) => {
            if (respuesta.data.data) {
              if (respuesta.data.data === "exito") {
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "Se Canceló la factura correctamente",
                });
                this.showModalFactura = false;
                this.obtenerRecibos();
                this.obtenerFacturas();
              } else {
                this.$swal.fire({
                  icon: "error",
                  title: "Aviso",
                  text: respuesta.data.data,
                });
                this.obtenerFacturas();
              }
            }
          })
          .catch((error) => {
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: error.message,
            });
          })
          .finally(() => {
            item.loadercancelar = false
          });
      },
      imprimir(item) {
        item.loaderRecibo = true;
        const envio = {
          idRecibo: item.idRecibo,
          horas: this.$horas(),
          esReciboPti: false
        };

        if ([2,7, 8, 9].includes(item.tipoRecibo)) {
          this.$http
            .post(this.$api + "reportes/recibo", envio)
            .then((respuesta) => {
              if (respuesta.data.data) {
                const datos = respuesta.data.data;

                this.descargar(respuesta.data.message, datos);
              }
            })
            .finally(() => {
              item.loaderRecibo = false;
            });
        } else {
          envio.esReciboPti = true;
          this.$http
            .post(this.$api + "reportes/recibo", envio)
            .then((respuesta) => {
              if (respuesta.data.data) {
                const datos = respuesta.data.data;
                this.descargar("Recibo-" + item.idRecibo + new Date(), datos);
              }
            })
            .finally(() => {
              item.loaderRecibo = false;
            });
        }
      },
     
      descargarFactura(datos) {
        const pdf = datos.pdf;
        const xml = datos.xml;
        const folio = datos.uid;
        const zip = new JSZip();
        zip.file(folio + ".xml", xml, {
          base64: false
        });
        zip.file(folio + ".pdf", pdf, {
          base64: true
        });
        zip.generateAsync({
          type: "blob"
        }).then(function (content) {
          saveAs(content, folio + ".zip");
        });
      },
      descargar(nombre, datos) {
        const byteCharacters = atob(datos);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
          const slice = byteCharacters.slice(offset, offset + 512);

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, {
          type: "application/pdf"
        });

        const url = window.URL.createObjectURL(blob);
        // window.open(url);
        const link = document.createElement("a");
        link.href = url;
        link.download = nombre;
        link.click();
      },
      facturar(item) {
        this.showModalFactura = true;
        this.factura.recibos = [];
        this.factura.recibos.push(item.idRecibo);
        this.factura.idClinica = this.$localStorageService.getIdClinica();
        this.factura.permiso = this.$localStorageService.getAuthorities().find(ele => ele == 'Fac_01_unAnio_conta');
        if(this.factura.permiso === undefined){
          this.factura.permiso = null;
        }
      },
      facturarVarios() {
        this.showModalFactura = true;
        this.factura.recibos = [];
        this.factura.idClinica = this.$localStorageService.getIdClinica();
        this.factura.permiso = this.$localStorageService.getAuthorities().find(ele => ele == 'Fac_01_unAnio_conta');
        if(this.factura.permiso === undefined){
          this.factura.permiso = null;
        }
        
        this.datosTablaRecibo.forEach((it) => {
          if (it.seleccion) {
            this.factura.recibos.push(it.idRecibo);
          }
        });
      },
      realizarFactura() {
        if(this.factura.idDatosFiscales == null) {
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: "Seleccione un RFC para poder facturar",
          });
          return false;
        }
        if(this.factura.cfdi == null){
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: "Seleccione un CFDI",
          });
          return false;
        }
        if (this.factura.recibos.length > 0) {
          this.$swal.fire({
            title: "<h6><b>Estos datos son los que se enviaran <br>¿Estas seguro de facturar?</b></h6>",
            html: '<h6>RFC: <span class="text-secondary"><small>'+ this.factura.idDatosFiscales.rfc +'</small></span></h6>'+
            '<h6 class="ml-4">Razón Social: <span class="text-secondary"><small>'+ this.factura.idDatosFiscales.nombreCompleto +'</small></span></h6>'+
            '<h6 style="margin-right: 152px;">Correo Electrónico: <span class="text-secondary"><small>'+ this.factura.idDatosFiscales.correo +'</small></span></h6>',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si',
            cancelButtonText: 'No'
          }).then((result) => {
            if (result.isConfirmed) {
              this.loaderFacturar = true;
              this.factura.horas = this.$horas();
              this.factura.puede = false;
              const envio = JSON.parse(JSON.stringify(this.factura));
              envio.idDatosFiscales = this.factura.idDatosFiscales.idDatosFiscales;
              this.$http
              .post(this.$api + "facturacion/timbrar", envio)
              .then((respuesta) => {
                if (respuesta.data.data) {
                  if (respuesta.data.data.includes("exito")) {
                    this.$swal.fire({
                      icon: "success",
                      title: "Muy Bien",
                      text: "¡Se generó la factura correctamente!",
                    });
                    this.cerrarModal();
                    this.obtenerRecibos();
                    this.obtenerFacturas();
                  } else {
                    let msj = "400 BAD REQUEST: [{\"message\": \"La raz\\u00f3n social no coincide\", \"data\": {}}]";
                    if(respuesta.data.data === msj){
                      this.$swal.fire({
                      icon: "error",
                      title: "Aviso",
                      text: respuesta.data.data,
                      showCancelButton: true,
                      confirmButtonText: 'Verificar Datos',
                      cancelButtonText: 'Cancelar',
                    }).then((result) => {
                      if (result.isConfirmed) {
                        //* Tomara los datos fiscales de lo que viene de factura.idDatosFiscales para editarlos
                        this.datoFiscal = this.factura.idDatosFiscales;
                        this.showModalFiscales = true;
                      }
                    })
                    }else{
                      this.$swal.fire({
                      icon: "error",
                      title: "Aviso",
                      html: respuesta.data.data,
                    });
                    this.cerrarModal();
                    this.obtenerFacturas();
                    }
                  }
                }
              })
              .finally(() => {
                this.loaderFacturar = false;
              });
            }
          })
          
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: "Seleccione el/los recibos a facturar",
          });
        }
      },

      actualizar() {
        if (this.datoFiscal.rfc !== 'XAXX010101000') {
          this.$v.datoFiscal.$touch();
          if (this.$v.datoFiscal.$anyError) {
            return;
          }
          if (!this.$v.datoFiscal.$invalid) {
            this.loaderFiscales = true;
            this.nombre();
            this.$http.post(this.$api + 'fiscales/guardar/datosFiscales', this.datoFiscal)
                .then(respuesta => {
                      if (respuesta.data.data) {
                        this.$swal.fire({
                          icon: "success",
                          title: "Muy Bien",
                          text: "¡Los datos se actualizaron correctamente!",
                        });
                        this.cerrarModal();
                        this.cerrarModalFiscales();
                        this.obtenerRfcs();
                        this.obtenerReembolsos();
                      }
                    }
                )
                .catch((reason) => {
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: reason.response.data.message,
                  });
                })
                .finally(() => {
                      this.loaderFiscales = false;
                    }
                )
          }
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: 'RFC no valido para un paciente',
          });
        }
      },

      nombre() {
        if (this.datoFiscal.tipoPersona === 1) {
          this.datoFiscal.nombre = "";
          this.datoFiscal.paterno = "";
          this.datoFiscal.materno = "";
          this.datoFiscal.nombreCompleto = this.datoFiscal.nombreCompleto.trim();
        } else {
          this.datoFiscal.nombre = this.datoFiscal.nombre.trim()
          this.datoFiscal.paterno = this.datoFiscal.paterno.trim();
          if(this.datoFiscal.materno != null){
          this.datoFiscal.materno = this.datoFiscal.materno.trim();
        }
        }
      },

      cerrarModal() {
        this.factura= {
        recibos: [],
        idDatosFiscales: null,
        cfdi: null,
        idClinica: null,
        datosPaciente: false,
        desglosada: false,
        permiso: null
        };
        this.showModalFactura = false;
      },

      cerrarModalFiscales(){
        this.datoFiscal = {
          idPaciente: null,
          idDatosFiscales: null,
          nacionalidad: null,
          rfc: null,
          tipoPersona: 1,
          nombre: null,
          nombreCompleto: null,
          paterno: null,
          materno: null,
          calle: null,
          numero: null,
          colonia: null,
          cp: null,
          pais: null,
          estado: null,
          correo: null
        },
        this.showModalFiscales = false;
      },

      obtenerFormasPago() {
        const parametros = {idPti: this.pti}
        const url = this.$api + "forma/activa";
        this.$http.post(url, parametros).then((response) => {
          response.data.data.forEach((i) => {
            if (i.idFormaPago === 7) {
              this.spei = true;
            }
          });
        });
      },
      validarTipo(item) {
        const valor = this.datosFiscales.filter(
          (value) => value.idDatosFiscales === item
        )[0];
        this.aparecerDOI = valor.tipoPersona === 1;
      },

      validateState(name) {
        const {$dirty, $error} = this.$v.datoFiscal[name];
        return $dirty ? !$error : null;
      },

      abrirModalTratamientos(item){
        console.log("item",item)
        this.modalTratamientos=true
        this.datosTablaTratamientos = item.tratamientos;
      },
    },
  };
</script>

<style scoped>
  .check-facturacion{
    vertical-align: middle;
    font-size: 13.4px;
  }

  .btns{
    margin: 0 auto;
  }
  
  .txt-rojo{
    color: rgb(231, 41, 41);
    font-size: 14px;
  }

</style>
